import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Handler from '../../../../Handler';
import { FormInput } from '../../../../components/form/FormInput';
import { FormSelect } from '../../../../components/form/FormSelect';
import { ReasonDetailField } from './ReasonDetailField';

export const CommonCreditFields = ({
  type,
  control,
  errors,
  register,
  watch,
  selectMenus,
  selectedMenu,
  reasonMenus,
  showProjectSeq = false,
  showAmount = false,
  showReasonDetail = false,
  reasonLabel,
  reasonDetailLabel,
  reasonDetailFieldName = 'reasonDetail',
  validations,
}) => {
  const { t } = useTranslation();
  const reason = watch('reason');
  const showCustomReason = reason === t('DIRECT_INPUT_SPACE');
  const amountLabel = {
    offset: t('WITHDRAWABLE_QUANTITY'),
    retire: t('DISPOSABLE_QUANTITY'),
    move: t('TRANSFERABLE_CREDIT_AMOUNT'),
    issue: t('REQUEST_CREDIT'),
  };
  const availableAmount = selectedMenu ? selectedMenu.amount : 0;

  return (
    <div className='flex flex-col gap-4'>
      {showProjectSeq && (
        <FormSelect
          label={t('BIZ_TITLE')}
          required
          name='projectSeq'
          control={control}
          menus={selectMenus}
          error={errors.projectSeq}
          rules={validations?.projectSeq}
        />
      )}
      {showAmount && (
        <div className='flex flex-col gap-1'>
          <Controller
            name='amount'
            control={control}
            rules={validations?.amount || { required: true, max: availableAmount }}
            render={({ field }) => (
              <FormInput
                label={t('AMOUNT')}
                required
                type='number'
                {...field}
                onChange={(e) => {
                  const value = e.target.value;
                  // 빈 값이거나 숫자가 아닌 경우 그대로 전달
                  if (value === '' || isNaN(value)) {
                    field.onChange(value);
                    return;
                  }
                  const numValue = Number(value);
                  // availableAmount보다 큰 값은 입력 불가
                  if (numValue > availableAmount) {
                    field.onChange(availableAmount);
                  } else {
                    field.onChange(value);
                  }
                }}
                inputProps={{
                  min: 0,
                  max: availableAmount,
                  disabled: !availableAmount,
                }}
                error={errors.amount}
                style={{ maxWidth: '420px' }}
              />
            )}
          />
          <span style={{ paddingTop: 8, marginLeft: 12, fontSize: 14, display: 'block' }}>
            * {amountLabel[type]} : <em style={{ color: '#5d3be5' }}>{Handler.numberWithCommas(availableAmount)}</em>{' '}
            VRC
            {t('CREDIT')}
          </span>
        </div>
      )}
      {reasonMenus && reasonMenus.length > 0 && (
        <FormSelect
          label={reasonLabel || t('REASON')}
          required
          name='reason'
          control={control}
          menus={reasonMenus}
          error={errors.reason}
          style={{ gridColumn: '1/3' }}
          rules={validations?.reason}
        />
      )}
      {showReasonDetail && (
        <ReasonDetailField
          control={control}
          errors={errors}
          reasonDetailFieldName={reasonDetailFieldName}
          reasonDetailLabel={reasonDetailLabel || t('REASON_DETAIL')}
          showCustomReason={true}
        />
      )}
      {!showReasonDetail && showCustomReason && (
        <ReasonDetailField
          control={control}
          errors={errors}
          reasonDetailFieldName={reasonDetailFieldName}
          reasonDetailLabel={reasonDetailLabel || t('REASON_DETAIL')}
          showCustomReason={showCustomReason}
        />
      )}
    </div>
  );
};
